import { render, staticRenderFns } from "./VehicleDeparture.vue?vue&type=template&id=0b16d3be&scoped=true"
import script from "./VehicleDeparture.vue?vue&type=script&lang=js"
export * from "./VehicleDeparture.vue?vue&type=script&lang=js"
import style0 from "./VehicleDeparture.vue?vue&type=style&index=0&id=0b16d3be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b16d3be",
  null
  
)

export default component.exports